import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './auth-context';

interface ProtectedRouteProps {
    requiredRoles?: string[];
    redirectTo?: string;
    isPublic?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRoles, redirectTo = '/login', isPublic = false }) => {
    const { isAuthenticated, userRoles, isLoading } = useAuth();

    // Wait until loading is complete
    if (isLoading) {
        return null; // Or render a loading spinner: <div>Loading...</div>
    }

    // Redirect authenticated users from public routes to home
    if (isPublic && isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // Redirect unauthenticated users from protected routes to login
    if (!isAuthenticated && !isPublic) {
        return <Navigate to={redirectTo} replace />;
    }

    // Check role-based access for protected routes
    if (requiredRoles && !requiredRoles.some(role => userRoles.includes(role))) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />;
};